/* LunaLuz — carte des praticiennes. Composant unique, sans dépendance hors Leaflet (optionnel).
   Fonctions pures exposées pour les tests node (module.exports) et le namespace window.LLZFeeNetwork.
   Rendu exclusivement via textContent / createElement, jamais par injection de balisage. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (typeof window !== 'undefined') {
    window.LLZFeeNetwork = window.LLZFeeNetwork || {};
    for (var k in api) { if (Object.prototype.hasOwnProperty.call(api, k)) { window.LLZFeeNetwork[k] = api[k]; } }
    window.LLZFeeNetwork.ready = false;
    window.LLZFeeNetwork.count = 0;
    window.LLZFeeNetwork.visible = 0;
    window.LLZFeeNetwork.mapReady = false;
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', api.boot); }
      else { api.boot(); }
    }
  }
})(this, function () {
  'use strict';

  function normalize(s) {
    s = String(s == null ? '' : s);
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* vieux moteurs */ }
    return s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function safeHttpUrl(v) {
    if (typeof v !== 'string') { return ''; }
    var s = v.trim();
    if (!s || /[\u0000-\u001f]/.test(s)) { return ''; }
    if (s.indexOf('://') === -1) {
      if (/^(javascript|data|vbscript|file|mailto):/i.test(s) || s.indexOf('@') !== -1) { return ''; }
      s = 'https://' + s;
    }
    var m = /^(https?):\/\/([^\/?#]+)([^#]*)/i.exec(s);
    if (!m) { return ''; }
    var netloc = m[2];
    if (netloc.indexOf('@') !== -1 || netloc.indexOf('.') === -1 || /[<>"'\s]/.test(netloc)) { return ''; }
    return m[1].toLowerCase() + '://' + netloc.toLowerCase() + (m[3] || '/');
  }

  function safeMailto(v) {
    if (typeof v !== 'string') { return ''; }
    var s = v.trim().toLowerCase();
    return /^[^@\s\/<>]+@[^@\s\/<>]+\.[a-z0-9-]+$/.test(s) ? 'mailto:' + s : '';
  }

  function safeTel(v) {
    if (typeof v !== 'string') { return ''; }
    var d = v.replace(/[^0-9+]/g, '');
    if (d.indexOf('+') > 0) { d = d.replace(/\+/g, ''); }
    return /^\+?[0-9]{8,15}$/.test(d) ? 'tel:' + d : '';
  }

  function directionsUrl(loc) {
    if (!isFiniteNum(loc.latitude) || !isFiniteNum(loc.longitude)) { return ''; }
    return 'https://www.openstreetmap.org/directions?to=' + encodeURIComponent(loc.latitude + ',' + loc.longitude);
  }

  function isFiniteNum(n) { return typeof n === 'number' && isFinite(n); }

  function safeAssetName(name) {
    return (typeof name === 'string' && /^[a-z0-9][a-z0-9._-]{0,80}\.(png|jpg|jpeg|webp)$/i.test(name)) ? name : '';
  }

  /* Ne conserve que des enregistrements exploitables et des champs texte. Déduplique par id. */
  function sanitizeLocations(raw) {
    var out = [], seen = {};
    if (!raw || !Array.isArray(raw)) { return out; }
    for (var i = 0; i < raw.length; i++) {
      var r = raw[i];
      if (!r || typeof r !== 'object' || typeof r.id !== 'string' || !r.id || seen[r.id]) { continue; }
      var lat = Number(r.latitude), lon = Number(r.longitude);
      var name = String(r.name || '').trim();
      if (!name) { continue; }
      seen[r.id] = true;
      out.push({
        id: r.id,
        name: name,
        address_line_1: str(r.address_line_1), address_line_2: str(r.address_line_2),
        city: str(r.city), postal_code: str(r.postal_code), country: str(r.country), full_address: str(r.full_address),
        latitude: isFinite(lat) && lat >= -90 && lat <= 90 && r.latitude !== null ? lat : null,
        longitude: isFinite(lon) && lon >= -180 && lon <= 180 && r.longitude !== null ? lon : null,
        phone: str(r.phone), email: str(r.email), website: str(r.website), description: str(r.description),
        fairy_name: str(r.fairy_name), fairy_image: safeAssetName(r.fairy_image),
        profession: str(r.profession), company_name: str(r.company_name), location_note: str(r.location_note),
        instagram: safeHttpUrl(r.instagram), facebook: safeHttpUrl(r.facebook), linkedin: safeHttpUrl(r.linkedin), tiktok: safeHttpUrl(r.tiktok),
        _search: normalize([r.name, r.city, r.postal_code, r.address_line_1, r.country, r.fairy_name, r.profession, r.company_name].join(' '))
      });
    }
    return out;
  }
  function str(v) { return typeof v === 'string' ? v.trim() : ''; }

  function filterLocations(locations, query) {
    var q = normalize(query);
    if (!q) { return locations.slice(); }
    var tokens = q.split(' ');
    var out = [];
    for (var i = 0; i < locations.length; i++) {
      var hay = locations[i]._search || normalize([locations[i].name, locations[i].city, locations[i].postal_code, locations[i].fairy_name, locations[i].profession, locations[i].company_name].join(' '));
      var ok = true;
      for (var t = 0; t < tokens.length; t++) { if (hay.indexOf(tokens[t]) === -1) { ok = false; break; } }
      if (ok) { out.push(locations[i]); }
    }
    return out;
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371.0088, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLon = (lon2 - lon1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  function sortByDistance(locations, lat, lon) {
    var withD = locations.map(function (l) {
      var d = (l.latitude !== null && l.longitude !== null) ? haversineKm(lat, lon, l.latitude, l.longitude) : Infinity;
      return { loc: l, d: d };
    });
    withD.sort(function (a, b) { return a.d - b.d || a.loc.name.localeCompare(b.loc.name); });
    return withD;
  }

  /* ---------------------------------------------- recherche de commune (Géoplateforme / BAN) */
  var GEOCODE_ENDPOINTS = ['https://data.geopf.fr/geocodage/search/', 'https://api-adresse.data.gouv.fr/search/'];

  function isPostcode(q) { return /^[0-9]{5}$/.test(String(q == null ? '' : q).replace(/\s+/g, '')); }

  function geocodeUrl(base, q) {
    var s = String(q == null ? '' : q).trim().slice(0, 80);
    if (isPostcode(s)) { s = s.replace(/\s+/g, ''); }
    return base + '?q=' + encodeURIComponent(s) + '&type=municipality&limit=5';
  }

  /* GeoJSON BAN -> [{name, postcode, citycode, context, lat, lon, score}] ; ignore tout le reste. */
  function parseGeocodeResponse(doc) {
    var out = [], seen = {};
    var feats = doc && Array.isArray(doc.features) ? doc.features : [];
    for (var i = 0; i < feats.length && out.length < 5; i++) {
      var f = feats[i], p = f && f.properties, g = f && f.geometry;
      if (!p || !g || !Array.isArray(g.coordinates) || g.coordinates.length < 2) { continue; }
      if (p.type && p.type !== 'municipality') { continue; }
      var lon = Number(g.coordinates[0]), lat = Number(g.coordinates[1]);
      if (!isFinite(lat) || !isFinite(lon) || lat < -90 || lat > 90 || lon < -180 || lon > 180) { continue; }
      var name = str(p.city) || str(p.name) || str(p.label);
      if (!name) { continue; }
      var key = str(p.citycode) || (name + '|' + str(p.postcode));
      if (seen[key]) { continue; }
      seen[key] = true;
      out.push({ name: name.slice(0, 80), postcode: str(p.postcode).slice(0, 10), citycode: str(p.citycode).slice(0, 10),
        context: str(p.context).slice(0, 80), lat: lat, lon: lon, score: Number(p.score) || 0 });
    }
    return out;
  }

  /* Commune retenue : nom identique à la saisie d'abord, sinon le 1er résultat (le plus pertinent pour la BAN). */
  function pickPlace(places, q) {
    if (!places || !places.length) { return null; }
    var nq = normalize(q);
    for (var i = 0; i < places.length; i++) { if (normalize(places[i].name) === nq) { return places[i]; } }
    return places[0];
  }

  /* 'place' = trier par distance depuis une commune ; 'text' = filtre par nom/activité/fée. */
  function searchMode(locations, q) {
    var nq = normalize(q);
    if (!nq) { return 'none'; }
    if (isPostcode(q)) { return 'place'; }
    for (var i = 0; i < locations.length; i++) { if (normalize(locations[i].city) === nq) { return 'place'; } }
    return filterLocations(locations, q).length ? 'text' : 'place';
  }

  /* « 10, Aube, Grand Est » -> « — Aube » ; sert à distinguer deux communes homonymes. */
  function contextDept(ctx) {
    var parts = String(ctx || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var dept = parts.length > 1 ? parts[1] : (parts[0] || '');
    return dept ? ' — ' + dept : '';
  }

  function placeLabel(p) { return p.postcode ? p.name + ' (' + p.postcode + ')' : p.name; }

  function formatKm(d) {
    if (!isFiniteNum(d) || d < 0) { return ''; }
    if (d < 1) { return 'moins de 1 km'; }
    var v = d < 10 ? (Math.round(d * 10) / 10).toFixed(1).replace('.', ',') : String(Math.round(d));
    if (v.slice(-2) === ',0') { v = v.slice(0, -2); }
    return '≈ ' + v + ' km';
  }

  function formatAddress(l) {
    var line1 = [l.address_line_1, l.address_line_2].filter(Boolean).join(', ');
    var line2 = [l.postal_code, l.city].filter(Boolean).join(' ');
    if (!line2 && l.country && !/^france$/i.test(l.country)) { line2 = l.country; }
    return [line1, line2].filter(Boolean);
  }

  function cityLabel(l) {
    if (l.city) { return l.city; }
    if (l.country && !/^france$/i.test(l.country)) { return l.country; }
    return l.postal_code || '';
  }

  /* Contact links are rendered once; legacy descriptions are not a second link list. */
  function contactContent(l) {
    var links = [], seen = {}, networks = {}, pendingLabel = '';
    var labels = {instagram:'Instagram', facebook:'Facebook', linkedin:'LinkedIn', tiktok:'TikTok', youtube:'YouTube'};
    function network(url) {
      var host = url.replace(/^https?:\/\//i, '').split(/[\/:?#]/)[0].toLowerCase();
      var keys = Object.keys(labels);
      for (var k = 0; k < keys.length; k++) {
        if (host === keys[k] + '.com' || host.slice(-(keys[k].length + 5)) === '.' + keys[k] + '.com') { return keys[k]; }
      }
      return host === 'youtu.be' ? 'youtube' : '';
    }
    function add(href, label) {
      var key = href.replace(/\/$/, '');
      if (!seen[key]) { links.push({href:href, label:label}); seen[key] = true; }
    }
    function addWeb(raw, hint) {
      raw = str(raw);
      // Reject broken copy/pastes as a whole. Never invent a repaired profile URL.
      if (!raw || /[\s\u0000-\u001f\u007f\u200b-\u200f\ufeff<>"']/.test(raw)) { return; }
      var url = safeHttpUrl(raw);
      if (!url) { return; }
      try { if (!(new URL(url)).hostname.match(/\.[a-z]{2,}$/i)) { return; } } catch (e) { return; }
      var kind = network(url);
      if (kind && networks[kind]) { return; }
      if (kind) { networks[kind] = true; }
      add(url, kind ? labels[kind] : (hint || 'Site'));
    }
    var tel = safeTel(l.phone), mail = safeMailto(l.email);
    if (tel) { add(tel, l.phone); }
    if (mail) { add(mail, 'E-mail'); }
    // Structured social fields take precedence over older free-text links.
    Object.keys(labels).forEach(function (key) { addWeb(l[key], labels[key]); });
    addWeb(l.website, 'Site');
    var text = [];
    str(l.description).split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line) { return; }
      var label = /^(Instagram|Facebook|LinkedIn|TikTok|YouTube|Website|Site(?:\s+(?:web|internet))?)(?:\s+link)?\s*(?::|[–—-])?\s*(.*)$/i.exec(line);
      if (label) {
        pendingLabel = labels[label[1].toLowerCase()] || 'Site';
        if (label[2]) { addWeb(label[2], pendingLabel); pendingLabel = ''; }
        return;
      }
      if (/^liens?\s+(?:vers\s+)?(?:les\s+)?r[eé]seaux\s+sociaux/i.test(line)) { return; }
      if (/^(?:https?:\/\/|www\.)/i.test(line)) { addWeb(line, pendingLabel || 'Site'); pendingLabel = ''; return; }
      pendingLabel = '';
      // Inline URLs become labelled links too, without HTML injection.
      line = line.replace(/(?:https?:\/\/|www\.)[^\s<>]+/gi, function (url) { addWeb(url, 'En savoir plus'); return ''; }).trim();
      if (line) { text.push(line); }
    });
    var rank = {'E-mail':1, Site:2, Instagram:3, Facebook:4, LinkedIn:5, TikTok:6, YouTube:7};
    links.sort(function (a, b) {
      var ra = a.href.indexOf('tel:') === 0 ? 0 : (rank[a.label] == null ? 8 : rank[a.label]);
      var rb = b.href.indexOf('tel:') === 0 ? 0 : (rank[b.label] == null ? 8 : rank[b.label]);
      return ra - rb;
    });
    var dir = directionsUrl(l);
    if (dir) { add(dir, 'Itinéraire'); }
    return {links:links, description:text.join('\n').slice(0, 400)};
  }

  /* ---------------------------------------------------------------- DOM */
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text != null) { e.textContent = text; }
    return e;
  }

  function linkItem(href, label) {
    var li = el('li');
    var a = el('a', null, label);
    a.setAttribute('href', href);
    if (href.indexOf('http') === 0) { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener noreferrer nofollow'); }
    li.appendChild(a);
    return li;
  }

  function fairyImgUrl(assetBase, name) {
    return name ? assetBase + name : '';
  }

  function buildItem(l, ctx, distanceKm) {
    var li = el('li', 'llz-fn__item' + (l.fairy_image ? ' llz-fn__item--fairy' : ''));
    li.setAttribute('data-id', l.id);
    if (l.fairy_image) {
      var fig = el('div');
      var img = el('img', 'llz-fn__fairy');
      img.setAttribute('src', fairyImgUrl(ctx.assetBase, l.fairy_image));
      img.setAttribute('alt', l.fairy_name ? 'Fée ' + l.fairy_name : 'Fée LunaLuz');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('width', '64'); img.setAttribute('height', '64');
      fig.appendChild(img);
      if (l.fairy_name) { fig.appendChild(el('div', 'llz-fn__fairy-name', l.fairy_name)); }
      li.appendChild(fig);
    }
    var body = el('div');
    var title = el('button', 'llz-fn__title');
    title.setAttribute('type', 'button');
    title.appendChild(document.createTextNode(l.name));
    var city = cityLabel(l);
    if (city) { title.appendChild(document.createTextNode(' — ')); title.appendChild(el('span', 'llz-fn__city', city)); }
    title.setAttribute('aria-label', 'Voir ' + l.name + (city ? ' à ' + city : '') + ' sur la carte');
    title.addEventListener('click', function () { ctx.focusLocation(l, li); });
    body.appendChild(title);
    var lines = formatAddress(l);
    for (var i = 0; i < lines.length; i++) { body.appendChild(el('p', 'llz-fn__addr', lines[i])); }
    if (l.location_note) { body.appendChild(el('p', 'llz-fn__desc', l.location_note)); }
    if (isFiniteNum(distanceKm)) {
      body.appendChild(el('span', 'llz-fn__dist', formatKm(distanceKm) + ' à vol d’oiseau'));
    }
    var links = el('ul', 'llz-fn__links');
    var contact = contactContent(l);
    contact.links.forEach(function (link) { links.appendChild(linkItem(link.href, link.label)); });
    if (links.childNodes.length) { body.appendChild(links); }
    if (contact.description) { body.appendChild(el('p', 'llz-fn__desc', contact.description)); }
    li.appendChild(body);
    return li;
  }

  function buildPopup(l, ctx) {
    var box = el('div', 'llz-fn__popup');
    if (l.fairy_image) {
      var img = el('img', 'llz-fn__fairy');
      img.setAttribute('src', fairyImgUrl(ctx.assetBase, l.fairy_image));
      img.setAttribute('alt', l.fairy_name ? 'Fée ' + l.fairy_name : 'Fée LunaLuz');
      box.appendChild(img);
    }
    box.appendChild(el('strong', null, l.name));
    var lines = formatAddress(l);
    for (var i = 0; i < lines.length; i++) { box.appendChild(el('div', null, lines[i])); }
    if (l.location_note) { box.appendChild(el('div', null, l.location_note)); }
    var dir = directionsUrl(l);
    if (dir) { var a = el('a', null, 'Itinéraire'); a.setAttribute('href', dir); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener noreferrer'); box.appendChild(a); }
    return box;
  }

  function boot() {
    var rootEl = document.querySelector('[data-llz-fee-network]');
    if (!rootEl || rootEl.getAttribute('data-llz-booted')) { return; }
    rootEl.setAttribute('data-llz-booted', '1');
    var dataUrl = rootEl.getAttribute('data-json') || '';
    var assetBase = dataUrl.split('?')[0].replace(/[^\/]*$/, '');
    var input = rootEl.querySelector('.llz-fn__input');
    var list = rootEl.querySelector('.llz-fn__list');
    var status = rootEl.querySelector('.llz-fn__status');
    var mapEl = rootEl.querySelector('.llz-fn__map');
    var geoBtn = rootEl.querySelector('[data-action="geoloc"]');
    var resetBtn = rootEl.querySelector('[data-action="reset"]');
    var state = { all: [], visible: [], origin: null, map: null, markers: {}, layer: null, originLayer: null, seq: 0, cache: {} };
    var ns = window.LLZFeeNetwork;

    /* Bouton « Rechercher » + choix de commune, ajoutés ici : le template (custom_liquid) reste inchangé. */
    var searchBtn = el('button', 'llz-fn__btn llz-fn__btn--primary', 'Rechercher');
    searchBtn.setAttribute('type', 'button');
    searchBtn.setAttribute('data-action', 'search');
    var field = input ? input.closest('.llz-fn__field') : null;
    if (field && field.parentNode) { field.parentNode.insertBefore(searchBtn, field.nextSibling); }
    if (geoBtn) { geoBtn.classList.remove('llz-fn__btn--primary'); }
    if (input) {
      input.setAttribute('placeholder', 'Ex. : Troyes, 52100, massage…');
      input.setAttribute('enterkeyhint', 'search');
      var hint = el('span', 'llz-fn__hint', 'Saisissez votre ville ou votre code postal pour voir à combien de kilomètres se trouve chaque adresse.');
      hint.id = 'llz-fn-search-hint';
      if (field) { field.appendChild(hint); input.setAttribute('aria-describedby', 'llz-fn-search-hint'); }
    }
    var placesBox = el('div', 'llz-fn__places');
    placesBox.hidden = true;
    if (status && status.parentNode) { status.parentNode.insertBefore(placesBox, status.nextSibling); }

    function say(text) { if (status) { status.textContent = text; } }

    var ctx = {
      assetBase: assetBase,
      focusLocation: function (l, li) {
        var items = list.querySelectorAll('.llz-fn__item--active');
        for (var i = 0; i < items.length; i++) { items[i].classList.remove('llz-fn__item--active'); }
        if (li) { li.classList.add('llz-fn__item--active'); }
        if (state.map && l.latitude !== null && l.longitude !== null) {
          state.map.setView([l.latitude, l.longitude], Math.max(state.map.getZoom(), 13));
          var m = state.markers[l.id];
          if (m) { m.openPopup(); }
          if (window.innerWidth < 900) { mapEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        }
      }
    };

    function render(entries) {
      while (list.firstChild) { list.removeChild(list.firstChild); }
      if (!entries.length) {
        list.appendChild(el('li', 'llz-fn__empty', 'Aucune adresse ne correspond à votre recherche. Essayez une ville ou un code postal voisin.'));
      } else {
        var frag = document.createDocumentFragment();
        for (var i = 0; i < entries.length; i++) { frag.appendChild(buildItem(entries[i].loc, ctx, entries[i].d)); }
        list.appendChild(frag);
      }
      ns.visible = entries.length;
      updateMarkers(entries.map(function (e) { return e.loc; }));
    }

    function currentEntries() {
      var q = (state.origin && state.origin.source === 'place') ? '' : (input ? input.value : '');
      var filtered = filterLocations(state.all, q);
      if (state.origin) { return sortByDistance(filtered, state.origin.lat, state.origin.lon); }
      return filtered.map(function (l) { return { loc: l, d: undefined }; });
    }

    function refresh(announce) {
      var entries = currentEntries();
      render(entries);
      var total = state.all.length;
      var msg = entries.length === total ? total + ' adresses' : entries.length + ' adresse' + (entries.length > 1 ? 's' : '') + ' sur ' + total;
      if (state.origin) {
        msg = (state.origin.label ? 'Autour de ' + state.origin.label + ' : ' : '') + msg + ', de la plus proche à la plus éloignée';
        if (entries.length && isFiniteNum(entries[0].d)) {
          msg += '. La plus proche : ' + entries[0].loc.name + ', ' + formatKm(entries[0].d) + '. Distances à vol d’oiseau';
        }
      }
      if (announce !== false) { say(msg + '.'); }
      drawOrigin();
      fitVisible(entries.map(function (e) { return e.loc; }));
    }

    function drawOrigin() {
      if (!state.map || !window.L) { return; }
      if (!state.originLayer) { state.originLayer = window.L.layerGroup().addTo(state.map); }
      state.originLayer.clearLayers();
      if (state.origin && window.L.circleMarker) {
        window.L.circleMarker([state.origin.lat, state.origin.lon], { radius: 9, color: '#5b3a6e', weight: 3, fillColor: '#ffffff', fillOpacity: 1 })
          .bindTooltip(state.origin.label || 'Votre position')
          .addTo(state.originLayer);
      }
    }

    function showPlaces(places, current, intro) {
      while (placesBox.firstChild) { placesBox.removeChild(placesBox.firstChild); }
      var others = places.filter(function (p) { return !current || p.citycode !== current.citycode || p.name !== current.name; });
      if (!others.length) { placesBox.hidden = true; return; }
      placesBox.appendChild(el('span', 'llz-fn__places-label', intro));
      var ul = el('ul', 'llz-fn__places-list');
      others.forEach(function (p) {
        var li = el('li');
        var b = el('button', 'llz-fn__chip', placeLabel(p) + contextDept(p.context));
        b.setAttribute('type', 'button');
        b.addEventListener('click', function () { applyPlace(p, places); });
        li.appendChild(b);
        ul.appendChild(li);
      });
      placesBox.appendChild(ul);
      placesBox.hidden = false;
    }

    function hidePlaces() { placesBox.hidden = true; while (placesBox.firstChild) { placesBox.removeChild(placesBox.firstChild); } }

    function applyPlace(p, places) {
      state.origin = { lat: p.lat, lon: p.lon, label: placeLabel(p), source: 'place', query: input ? input.value : '' };
      if (resetBtn) { resetBtn.hidden = false; }
      refresh();
      showPlaces(places || [], p, 'Ce n’est pas la bonne commune ?');
    }

    function fetchPlaces(q) {
      var key = normalize(q);
      if (state.cache[key]) { return Promise.resolve(state.cache[key]); }
      function attempt(i) {
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var t = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
        return fetch(geocodeUrl(GEOCODE_ENDPOINTS[i], q), { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
          .then(function (doc) { clearTimeout(t); var ps = parseGeocodeResponse(doc); state.cache[key] = ps; return ps; },
            function (err) { clearTimeout(t); if (i + 1 < GEOCODE_ENDPOINTS.length) { return attempt(i + 1); } throw err; });
      }
      return attempt(0);
    }

    function submitSearch() {
      var q = input ? input.value.trim() : '';
      hidePlaces();
      if (!state.all.length) { return; }
      var mode = searchMode(state.all, q);
      if (mode === 'none') { if (state.origin && state.origin.source === 'place') { state.origin = null; } refresh(); return; }
      if (state.origin && state.origin.source === 'place') { state.origin = null; }
      var seq = ++state.seq;
      if (mode === 'text') {
        refresh();
        // Un mot qui est aussi une commune (ex. un prénom de fée) : proposer la commune sans l'imposer.
        if (q.length >= 3) {
          fetchPlaces(q).then(function (ps) {
            if (seq !== state.seq || !ps.length) { return; }
            var nq = normalize(q);
            var near = ps.filter(function (p) { return normalize(p.name).indexOf(nq) === 0; });
            if (near.length) { showPlaces(near, null, 'Voir les distances depuis la commune :'); }
          }, function () { /* silencieux : le filtre texte suffit */ });
        }
        return;
      }
      say('Recherche de « ' + q.slice(0, 60) + ' »…');
      searchBtn.disabled = true;
      fetchPlaces(q).then(function (ps) {
        if (seq !== state.seq) { return; }
        searchBtn.disabled = false;
        var p = pickPlace(ps, q);
        if (!p) {
          render(filterLocations(state.all, '').map(function (l) { return { loc: l, d: undefined }; }));
          say('Nous n’avons pas trouvé la commune « ' + q.slice(0, 60) + ' ». Vérifiez l’orthographe ou essayez un code postal.');
          return;
        }
        applyPlace(p, ps);
      }, function () {
        if (seq !== state.seq) { return; }
        searchBtn.disabled = false;
        say('La recherche de ville n’a pas abouti, sans doute un souci de connexion. Vous pouvez réessayer dans un instant ou utiliser « Autour de moi ».');
      });
    }

    function updateMarkers(locs) {
      if (!state.map || !state.layer) { return; }
      state.layer.clearLayers();
      state.markers = {};
      for (var i = 0; i < locs.length; i++) {
        var l = locs[i];
        if (l.latitude === null || l.longitude === null) { continue; }
        var opts = { title: l.name, alt: l.name };
        if (l.fairy_image) {
          opts.icon = window.L.icon({ iconUrl: fairyImgUrl(assetBase, l.fairy_image), iconSize: [36, 36], iconAnchor: [18, 36], popupAnchor: [0, -34], className: 'llz-fn__pin' });
        } else {
          opts.icon = window.L.divIcon({ className: 'llz-fn__dot', html: '', iconSize: [16, 16], iconAnchor: [8, 8], popupAnchor: [0, -10] });
        }
        var m = window.L.marker([l.latitude, l.longitude], opts);
        m.bindPopup(buildPopup(l, ctx));
        (function (loc) {
          m.on('click', function () {
            var li = list.querySelector('[data-id="' + loc.id.replace(/["\\]/g, '') + '"]');
            if (li) { li.scrollIntoView({ block: 'nearest' }); ctx.focusLocation(loc, li); }
          });
        })(l);
        m.addTo(state.layer);
        state.markers[l.id] = m;
      }
    }

    function fitVisible(locs) {
      if (!state.map) { return; }
      var pts = [];
      for (var i = 0; i < locs.length; i++) { if (locs[i].latitude !== null && locs[i].longitude !== null) { pts.push([locs[i].latitude, locs[i].longitude]); } }
      if (state.origin) { pts = pts.slice(0, state.origin.source === 'place' ? 5 : 12); pts.push([state.origin.lat, state.origin.lon]); }
      if (pts.length > 1) { state.map.fitBounds(pts, { padding: [24, 24], maxZoom: 13 }); }
      else if (pts.length === 1) { state.map.setView(pts[0], 12); }
    }

    function initMap() {
      if (!mapEl) { return; }
      if (!window.L || !window.L.map) {
        mapEl.classList.add('llz-fn__map--off');
        mapEl.textContent = 'La carte interactive ne s’est pas chargée ; la liste et la recherche ci-dessous restent disponibles.';
        return;
      }
      try {
        state.map = window.L.map(mapEl, { scrollWheelZoom: false, preferCanvas: true }).setView([46.6, 2.4], 5);
        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19, keepBuffer: 0,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
        }).addTo(state.map);
        state.layer = window.L.layerGroup().addTo(state.map);
        ns.mapReady = true;
      } catch (e) {
        state.map = null;
        mapEl.classList.add('llz-fn__map--off');
        mapEl.textContent = 'La carte interactive ne s’est pas chargée ; la liste et la recherche restent disponibles.';
      }
    }

    function geolocate() {
      if (!navigator.geolocation) { say('La géolocalisation n’est pas disponible sur cet appareil.'); return; }
      geoBtn.disabled = true;
      say('Recherche de votre position…');
      navigator.geolocation.getCurrentPosition(function (pos) {
        state.origin = { lat: pos.coords.latitude, lon: pos.coords.longitude, label: '', source: 'geo' };
        state.seq++;
        hidePlaces();
        if (input && input.value && searchMode(state.all, input.value) !== 'text') { input.value = ''; }
        geoBtn.disabled = false;
        if (resetBtn) { resetBtn.hidden = false; }
        refresh();
      }, function () {
        geoBtn.disabled = false;
        say('Position indisponible. Vous pouvez saisir une ville ou un code postal.');
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    }

    function reset() {
      state.origin = null;
      state.seq++;
      hidePlaces();
      if (input) { input.value = ''; }
      if (resetBtn) { resetBtn.hidden = true; }
      refresh();
      if (input) { input.focus(); }
    }

    if (input) {
      var timer = null;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        // Nouvelle saisie : la commune précédente ne s'applique plus.
        if (state.origin && state.origin.source === 'place' && input.value !== state.origin.query) { state.origin = null; state.seq++; hidePlaces(); }
        timer = setTimeout(function () { refresh(); }, 160);
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); submitSearch(); } });
    }
    searchBtn.addEventListener('click', function () { submitSearch(); });
    var formEl = rootEl.querySelector('form');
    if (formEl) { formEl.addEventListener('submit', function (e) { e.preventDefault(); submitSearch(); }); }
    if (geoBtn) { geoBtn.addEventListener('click', geolocate); }
    if (resetBtn) { resetBtn.addEventListener('click', reset); resetBtn.hidden = true; }

    initMap();
    say('Chargement des adresses…');
    if (!dataUrl || typeof fetch !== 'function') { say('Adresses indisponibles pour le moment.'); return; }
    fetch(dataUrl, { credentials: 'omit', cache: 'default' }).then(function (r) {
      if (!r.ok) { throw new Error('HTTP ' + r.status); }
      return r.json();
    }).then(function (doc) {
      var locs = sanitizeLocations(doc && doc.locations);
      if (!locs.length) { throw new Error('vide'); }
      state.all = locs;
      ns.count = locs.length;
      ns.ready = true;
      refresh();
      if (geoBtn) { geoBtn.disabled = false; }
    }).catch(function () {
      say('Les adresses n’ont pas pu être chargées. Merci de réessayer dans un instant.');
      list.appendChild(el('li', 'llz-fn__empty', 'Adresses momentanément indisponibles.'));
    });
  }

  return {
    normalize: normalize, safeHttpUrl: safeHttpUrl, safeMailto: safeMailto, safeTel: safeTel, directionsUrl: directionsUrl,
    sanitizeLocations: sanitizeLocations, filterLocations: filterLocations, haversineKm: haversineKm,
    sortByDistance: sortByDistance, formatAddress: formatAddress,
    isPostcode: isPostcode, geocodeUrl: geocodeUrl, parseGeocodeResponse: parseGeocodeResponse, pickPlace: pickPlace,
    searchMode: searchMode, placeLabel: placeLabel, contextDept: contextDept, formatKm: formatKm, GEOCODE_ENDPOINTS: GEOCODE_ENDPOINTS, cityLabel: cityLabel, safeAssetName: safeAssetName,
    contactContent: contactContent, boot: boot
  };
});
